"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Linked = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gatsby = require("gatsby");
var _segmentfunctions = require("../utils/segmentfunctions");
var _excluded = ["href", "className", "size", "label", "preventDefault", "title", "target", "children", "onClick", "trackObject"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Primary UI link for user interaction
 */
var Linked = function Linked(_ref) {
  var href = _ref.href,
    className = _ref.className,
    size = _ref.size,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    preventDefault = _ref.preventDefault,
    title = _ref.title,
    target = _ref.target,
    children = _ref.children,
    onClick = _ref.onClick,
    trackObject = _ref.trackObject,
    props = _objectWithoutProperties(_ref, _excluded);
  var trackFn = function trackFn() {};
  var isBlank = target === '_blank';
  //const _title = title || (isBlank ? "Opens in a new tab" : "Opens in the same tab");

  if (trackObject) {
    trackObject.name = trackObject.name || (isBlank ? "Outbound Link Clicked" : "Marketing CTA Clicked");
    var obj = _objectSpread({
      type: 'link'
    }, trackObject);
    obj.text = trackObject.text || label.replace(/(<([^>]+)>)/gi, "");
    obj.destination = trackObject.destination || href;
    trackFn = function trackFn() {
      (0, _segmentfunctions.segmentEvent)(trackObject.name, obj);
    };
  }
  var onClickNew = function onClickNew(e) {
    if (typeof onClick === 'function') {
      onClick.apply(this, arguments);
    }
    if (typeof preventDefault !== 'undefined') {
      e.preventDefault();
    }
    trackFn();
  };
  if ((href === null || href === void 0 ? void 0 : href.indexOf("http")) !== -1) {
    return /*#__PURE__*/_react["default"].createElement("a", _extends({
      onClick: onClickNew,
      className: "link ".concat(className, " ").concat(size),
      href: href,
      target: target || undefined
    }, props), children || label);
  }
  return /*#__PURE__*/_react["default"].createElement(_gatsby.Link, _extends({
    onClick: onClickNew,
    to: href,
    className: "link ".concat(className, " ").concat(size)
  }, props), children || label);
};
exports.Linked = Linked;
Linked.propTypes = {
  /**
   * What className to use (green-link etc)
   */
  className: _propTypes["default"].string,
  /**
   * How large should the Link be?
   */
  size: _propTypes["default"].oneOf(['tiny', 'small', 'medium', 'large']),
  /**
   * Link contents
   */
  label: _propTypes["default"].string,
  /**
   * Link href
   */
  href: _propTypes["default"].string.isRequired,
  /**
   * Link title
   */
  title: _propTypes["default"].string,
  /**
   * preventDefault - pass any value to disable click following
   */
  preventDefault: _propTypes["default"].string,
  /**
   * Link target
   */
  target: _propTypes["default"].string,
  /**
   * Segments trackObject object e.g.   `{name: "Marketing CTA Clicked"}`
   * ///////////////////
   * `destination` is populated from `Link href`
   */
  trackObject: _propTypes["default"].object,
  /**
   * Optional click handler
   */
  onClick: _propTypes["default"].func
};
Linked.defaultProps = {
  href: '#',
  size: 'medium'
};